import { createActionGroup, emptyProps, props } from "@ngrx/store";
import type { CreatePartInput, Part } from "@partikelart/parts/domain";

export const PartActions = createActionGroup({
	source: "Part",
	events: {
		"Load Parts": props<{ siteId?: string }>(),
		"Load Parts Success": props<{ parts: Part[] }>(),
		"Load Parts Failure": props<{ error: string }>(),

		"Load Part By Id": props<{ id: string }>(),
		"Load Part By Id Success": props<{ part: Part }>(),
		"Load Part By Id Failure": props<{ error: string }>(),

		"Load Part By Number": props<{ partNumber: string }>(),
		"Load Part By Number Success": props<{ part: Part }>(),
		"Load Part By Number Failure": props<{ error: string }>(),

		"Set Current Part": props<{ part: Part | null }>(),
		"Clear Current Part": emptyProps(),
		"Create Part": props<{ input: CreatePartInput }>(),
		"Create Part Success": props<{ part: Part }>(),
		"Create Part Failure": props<{ error: string }>(),

		"Update Part": props<{ id: string; changes: Partial<Part> }>(),
		"Update Part Success": props<{ part: Part }>(),
		"Update Part Failure": props<{ error: string }>(),

		"Delete Part": props<{ id: string }>(),
		"Delete Part Success": props<{ id: string }>(),
		"Delete Part Failure": props<{ error: string }>(),

		"Set Current Part Form Image Path": props<{ path: string | null }>(),
	},
});
